var _rect, _rect2, _rect3, _rect4, _rect5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    stroke: "#9A9A9A",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10.6,
    width: 9.6,
    height: 9.6,
    rx: 0.8,
    transform: "rotate(-90 1 10.5996)",
    fill: "none",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10.6,
    width: 9.6,
    height: 9.6,
    rx: 0.8,
    transform: "rotate(-90 1 10.5996)",
    fill: "none",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18.6,
    width: 4.8,
    height: 9.6,
    rx: 0.8,
    transform: "rotate(-90 1 18.5996)",
    fill: "none",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 10.6,
    width: 9.6,
    height: 4.8,
    rx: 0.8,
    transform: "rotate(-90 13.8008 10.5996)",
    fill: "none",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 18.6,
    width: 4.8,
    height: 4.8,
    rx: 0.8,
    transform: "rotate(-90 13.8008 18.5996)",
    fill: "none",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.6887f9bc.svg";
export { ForwardRef as ReactComponent };